'use client';

import { useDepositOrderTracking } from '@/queries/orders/useDepositOrderTracking';

export default function AppStartupEffect() {
  useDepositOrderTracking();

  return null;
}
